import styled from 'styled-components';
import { dimension, padding, font, animation, overflow } from '../styleHelper2';

const TableCell = styled.td`
  text-align: left;
  padding: ${props => props.theme.padding.normal};
  border-left: solid 1px ${props => props.theme.border.border300};
  &:first-child {
    border: none;
  }
  ${dimension()}
  ${padding()}
  ${font()}
  ${overflow()}
  ${animation()}
`;

export default TableCell;
